import { getFreshFbc, getFreshFbp, getMetaAttribution } from "@/lib/tracking/meta-attribution"
import { api } from "@services/api"

/**
 * Send a Meta CAPI event to the backend for server-side tracking.
 * Fire-and-forget: never throws, never blocks the UI.
 */
export async function sendCapiEvent(
  eventName: string,
  eventId: string,
  customData?: Record<string, unknown>
): Promise<void> {
  try {
    const attribution = getMetaAttribution()

    // Read fresh fbc/fbp from Meta lib at send time, fall back to stored values
    const fbc = getFreshFbc() || attribution?.fbc || undefined
    const fbp = getFreshFbp() || attribution?.fbp || undefined

    await api.post("/tracking/meta-event", {
      event_name: eventName,
      event_id: eventId,
      event_source_url: window.location.href,
      fbc,
      fbp,
      page_title: document.title || undefined,
      page_referrer: document.referrer || undefined,
      custom_data: customData,
    })
  } catch {
    // Fire-and-forget: don't let tracking errors affect the user experience
  }
}
